import { ILogFormatter, ILogMessage } from '../types';

/**
 * Base Formatter class - defines the interface for custom Formatters
 */
export class Formatter implements ILogFormatter {
  format(_message: ILogMessage): ILogMessage {
    throw new Error('Not Implemented');
  }
}
